"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Accordion = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireDefault(require("react"));
var _reactUseControlledState = _interopRequireDefault(require("@quid/react-use-controlled-state"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Section = require("./Section");
require("./Accordion.scss");
var Accordion = function Accordion(_ref) {
  var _ref$children = _ref.children,
    children = _ref$children === void 0 ? [] : _ref$children,
    openIndexArray = _ref.openIndexArray,
    defaultOpenIndexArray = _ref.defaultOpenIndexArray,
    _ref$isMultiple = _ref.isMultiple,
    isMultiple = _ref$isMultiple === void 0 ? false : _ref$isMultiple,
    onChange = _ref.onChange,
    title = _ref.title,
    className = _ref.className,
    sectionClassName = _ref.sectionClassName,
    sectionTitleClassName = _ref.sectionTitleClassName,
    sectionContentClassName = _ref.sectionContentClassName;
  var _useControlledState = (0, _reactUseControlledState["default"])(defaultOpenIndexArray, openIndexArray, onChange),
    _useControlledState2 = (0, _slicedToArray2["default"])(_useControlledState, 2),
    stateOpenIndexArray = _useControlledState2[0],
    setStateOpenIndexArray = _useControlledState2[1];
  var handleSectionClick = function handleSectionClick(index) {
    if (isMultiple || stateOpenIndexArray && stateOpenIndexArray.includes(index)) {
      return setStateOpenIndexArray(Array.from(new Set([].concat((0, _toConsumableArray2["default"])(stateOpenIndexArray.filter(function (value) {
        return value !== index;
      })), (0, _toConsumableArray2["default"])([index].filter(function (value) {
        return !stateOpenIndexArray.includes(value);
      }))))));
    }
    return setStateOpenIndexArray([index]);
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('cds-Accordion', className)
  }, title && /*#__PURE__*/_react["default"].createElement("div", {
    className: "cds-Accordion-Title"
  }, title), _react["default"].Children.map(children, function (section, index) {
    return /*#__PURE__*/_react["default"].cloneElement(section, {
      index: index,
      isOpen: stateOpenIndexArray.includes(index),
      key: index,
      onClick: function onClick() {
        return handleSectionClick(index);
      },
      className: sectionClassName,
      titleClassName: sectionTitleClassName,
      contentClassName: sectionContentClassName
    });
  }));
};
exports.Accordion = Accordion;
Accordion.Section = _Section.Section;